import { UserStatus } from 'src/api';
import { SxProp } from 'src/types/mui';

export const userStatusChipStyles: Record<UserStatus, SxProp> = {
  [UserStatus.Active]: theme => ({
    backgroundColor: theme.palette.chip?.success?.main,
    color: theme.palette.chip?.success?.contrastText,
    borderColor: theme.palette.chip?.success?.contrastText,
  }),
  [UserStatus.Inactive]: theme => ({
    backgroundColor: theme.palette.chip?.error?.main,
    color: theme.palette.chip?.error?.contrastText,
    borderColor: theme.palette.chip?.error?.contrastText,
  }),
  [UserStatus.Pending]: theme => ({
    backgroundColor: theme.palette.chip?.warning?.main,
    color: theme.palette.chip?.warning?.contrastText,
    borderColor: theme.palette.chip?.warning?.contrastText,
  }),
};
